import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('vulnerability-dropdown-iv-llc-dev-panel');
	},
};
